/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import React, {
	useEffect,
	useState
} from "react";
import {
	useLocation,
	useNavigate
} from "react-router-dom";

import {
	ComponentWrapper,
	ReservationOverlayWrapper,
	StoreOverlayWrapper
} from "./Lists.styled";

import Card, {
	CardBody,
	CardFooter,
	CardHeader
} from "../../components/Card";
import Img from "../../components/Img"; 
import LoaderAnimation from "../../components/LoaderAnimation";

import routerHelper from "../../helpers/router";
import storeHelper from "../../helpers/store";
import utilsHelper from "../../helpers/utils";

import useApi from "../../hooks/api";

import i18n from "../../i18n";

// COMPONENT

const Lists = (props) => {
	const [
		isRenderReady, 
		setIsRenderReady
	] = useState(false);
	const [
		events, 
		setEvents
	] = useState(null);

	const {
		fetchApi
	} = useApi();
	const location = useLocation();
	const navigate = useNavigate();

	// Lifecycle

	// Note - Run on bootstrap
	useEffect(
		() => {
			const waitAsync = async () => {
				const response = await fetchApi({
					method: "get",
					params: {
						service: "getUserListed"
					}
				});

				if(!response?.error) {
					const newEvents = response.payload.listed.map((item) => {
						return {
							date: item.event.date,
							id: item.event.id,
							product: {
								image: item.event.product.images[0],
								name: item.event.product.name
							},
							store: {
								address: item.store.address,
								city: item.store.city,
								logo: item.store.logo,
								name: item.store.name,
								postalCode: item.store.postal_code
							},
							user: {
								boost: 
									item.event.boost ||
									null
								,
								boostToken: 
									item.event.boostToken ||
									null
								,
								confirmationCode: item.event.confirmation_code,
								name: item.event.user_name,
								selection: item.event.product.size
							}
						};
					});

					setEvents(newEvents);
				}
			};

			waitAsync();
	    }, 
		[]
	);

	// Note - Run when events change
	useEffect(
		() => {
			if(!utilsHelper.isArray(events)) {
				return;
			}

			setIsRenderReady(true);
		}, 
		[events]
	);

	// Misc

	/**
	 * goToStoreRules - ...
	 * 
	 * @param {string} eventId ... 
	 */
	const goToStoreRules = (eventId) => {
		navigate({
			pathname: routerHelper.getUrl(
				"storeRules",
				{
					eventId: eventId
				}
			)
		});
	};

	// Render

	/**
	 * render - ...
	 */
	const render = () => {
		let content;

		if(isRenderReady) {
			if(!utilsHelper.isArrayEmpty(events)) {
				content = renderEvents();
			} else {
				// empty state
			}
		} else {
			// loader
		}

		return (
			<ComponentWrapper>			
				{content}
			</ComponentWrapper>
		);
	};

	/**
	 * renderEvents - ...
	 */
	const renderEvents = () => {
		return events.map((item) => {
			let boostContent;
			let sizeContent;
			let sizeText;

			//...boost

			if(item.boost > 1) {
				boostContent = (
					<div
						className="boost"
						>
						{`x ${item.boost}`}
					</div>
				);
			}

			switch(item.user.selection.type) {
				case "apparel":
				case "shoe":
					sizeText = i18n.t(
						`general.sizes.${item.user.selection.gender}`,
						{
							size: item.user.selection.size
						}
					);
				break;
				case "time":
					sizeText = item.user.selection.timeSlot;
				break;
			}

			if(sizeText) {
				sizeContent = (
					<p>
						<span>
							{sizeText}
						</span>
					</p>
				);
			}
			
			return (
				<Card
					key={item.id}
					>
					<CardHeader
						className="reservationCardHeader"
						>
						<Img
							alt={item.product.name}
							className="img"
							src={item.product.image}
						/>
						<ReservationOverlayWrapper>
							{boostContent}
							<span>
								{item.user.name}
							</span>
							<strong>
								{item.user.confirmationCode}
							</strong>
							<p>
								<strong>
									{item.product.name}
								</strong>
							</p>
							{sizeContent}
						</ReservationOverlayWrapper>
					</CardHeader>
					<CardBody
						className="reservationCardBody"
						>
						<StoreOverlayWrapper>
							<Img
								alt={item.store.name}
								className="img"
								src={item.store.logo}
							/>
						</StoreOverlayWrapper>
						<strong>
							{item.store.name}
						</strong>
						<p>
							<small>
								{item.store.address}
							</small>
							<small>
								{`${item.store.city}, ${item.store.postalCode}`}
							</small>
						</p>
					</CardBody>
					<CardFooter>
						<a
							onClick={(e) => goToStoreRules(item.id)}
							>
							Store rules
						</a>
					</CardFooter>
				</Card>
			);
		});
	};

	return render();
};

// EXPORT

export default Lists;
